export default __webpack_public_path__ + "static/media/pinnedAwaitingIcon.1239e04f.svg";